import styled from 'styled-components'

import { Link } from 'react-router-dom'
import { Text } from 'components/Text'

export const SidebarItemIcon = styled.img``
export const SidebarItemLabel = styled(Text)`
  color: #969ba0;
  font-size: 1.125rem;
  line-height: 1.125rem;
`

export const SidebarItemContainer = styled(Link)<{ isActive: boolean }>`
  text-decoration: none;
  display: grid;
  grid-template: 1fr / 3rem calc(100% - 3rem);
  padding: 1.5rem 0 1.5rem 3.125rem;
  align-items: center;
  position: relative;
  cursor: pointer;
  background-color: ${({ isActive }) => (isActive ? '#fafbff' : 'transparent')};
  &::after {
    position: absolute;
    content: '';
    width: 0.5rem;
    height: 100%;
    top: 0;
    bottom: 0;
    left: 0;
    border-top-right-radius: 6px;
    border-bottom-right-radius: 6px;
    background-color: ${({ theme }) => theme.colors.primary};
    opacity: ${({ isActive }) => (isActive ? 1 : 0)};
    transition: all 0.25 ease-in;
  }

  ${SidebarItemLabel} {
    color: ${({ isActive, theme }) =>
      isActive ? theme.colors.primary : '969ba0'};
    font-weight: ${({ isActive }) => (isActive ? 'bold' : '500')};
  }

  &:hover {
    background-color: #fafbff;
    &::after {
      opacity: 1;
    }
    ${SidebarItemLabel} {
      color: ${({ theme }) => theme.colors.primary};
      font-weight: bold;
    }
  }
`
